/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc
 */

export const getPaymentMethodUpdateRequestUrlRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'getPaymentMethodUpdateRequestUrl',
  auth: 'external',
  fingerprint: 'tzCjKwmbOzphq52i6TP_9LYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicePaymentInfoRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'getInvoicePaymentInfo',
  auth: 'external',
  fingerprint: 'nJDqTHmOCixJzKJvzO4kSLYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReceiptEmailRecipientsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'getReceiptEmailRecipients',
  auth: 'external',
  fingerprint: 'TaYQaifS_2y6NSIi7Y_Cg7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resendReceiptEmailRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'resendReceiptEmail',
  auth: 'external',
  fingerprint: 'dvL8IFXPle4FC8kTedeYsbYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelSubscriptionRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'cancelSubscription',
  auth: 'external',
  fingerprint: 'wqFBWUbI4waRDoANIloaIrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};